import Vue from 'vue'
import VueRouter from 'vue-router';
import Callback from '../components/Callback';
import HoleSummary from '../components/HoleSummary';
import Home from '../components/Home';
import PlayerSummary from '../components/PlayerSummary';
import SeasonStandings from '../components/SeasonStandings';
import SeasonWeeks from '../components/SeasonWeeks';
import Sponsors from '../components/Sponsors';
import TopTen from '../components/TopTen';
import WeekScoreCard from '../components/WeekScoreCard';
import AdminHome from '../components/admin/AdminHome';
import SeasonManagement from '../components/admin/SeasonManagement';
import PlayerManagement from '../components/admin/PlayerManagement';
import WeekList from '../components/admin/WeekList';
import WeekEditor from '../components/admin/WeekEditor';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Home },
  { path: '/sponsors', component: Sponsors },
  { path: '/:seasonId/:seasonName/top10', component: TopTen, props: true },
  { path: '/:seasonId/:seasonName/standings', component: SeasonStandings, props: true },
  { path: '/:seasonId/:seasonName/holes', component: HoleSummary, props: true },
  { path: '/:seasonId/:seasonName/player/:playerId/:playerName', name: 'playerStats', component: PlayerSummary, props: true },
  { path: '/:seasonId/:seasonName/weeks', component: SeasonWeeks, props: true },
  { path: '/:seasonId/:seasonName/weeks/:week/scores', name: 'weekScoreCard', component: WeekScoreCard, props: true },
  { path: '/admin/home', component: AdminHome, beforeEnter: adminGuard },
  { path: '/admin/seasons', component: SeasonManagement, beforeEnter: adminGuard },
  { path: '/admin/players', component: PlayerManagement, beforeEnter: adminGuard },
  { path: '/admin/rounds', component: WeekList, beforeEnter: adminGuard },
  { path: '/admin/rounds/new', component: WeekEditor, beforeEnter: adminGuard },
  { path: '/admin/rounds/:seasonId/:seasonName/:week', component: WeekEditor, props: true, beforeEnter: adminGuard },
  { path: '*', component: Callback }
];

const router = new VueRouter({
  routes
});

function adminGuard (to, from, next) {
  if (!Vue.authService.isAuthenticated()) {
    router.replace('/')
    return;
  }
  next();
}

export default router;
